import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getCustomer(c,id)
  {
    const url = apiUrl + 'Customer/Get?id='+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async addProductToOrder(c,{id,attr_hash,car_id,customer_id})
  {
    let url = apiUrl + 'customerOrder/AddNewProduct';
    url += '?product_id='+id;
    url += '&customer_id='+customer_id;
    url += '&attr='+attr_hash;
    url += '&car_id='+car_id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async addServiceToOrder(c,{service_id,car_id})
  {
    let url = apiUrl + 'customerOrder/AddNewService';
    url += '?service_id='+service_id+'&car_id='+car_id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async submitOrder(c,items)
  {
    let url = apiUrl + 'submitOrder';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getOrder(c,id)
  {
    let url = apiUrl + 'Order/Get/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getOrderItems(c,id)
  {
    let url = apiUrl + 'Order/getItems?order_id='+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async editOrderItems(c,items)
  {
    let url = apiUrl + 'Order/EditOrderItem/';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getProductToSetLastService(c,id)
  {
    let url = apiUrl + 'Order/getProductToSetLastService?order_id='+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async finishOrder(c,items)
  {
    let url = apiUrl + 'Order/changeStatusToFinish';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getServicesForOrder(c,car_id)
  {
    let url = apiUrl + 'getServiceForOrder?car_id='+car_id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  } ,
  async getProductsOfService(c,{car_id,service_id})
  {
    let url = apiUrl + 'getProductsOfService?car_id='+car_id;
    url += '&service_id='+service_id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async numberOfOrder()
  {
    let url = apiUrl + 'numberOfOrder';
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async changeOrderDebt(c,{order_id ,debt})
  {
    let url = apiUrl + 'changeOrderDebt?id='+order_id+'&debt='+debt;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getOilAmount()
  {
    let url = apiUrl + 'getOilAmount';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async getCustomerProduct(c,customer_id)
  {
    let url = apiUrl + 'getCustomerProduct?customer_id='+customer_id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data;
    }
  },
  async checkProductToAddOrderEdit(c,items)
  {
    let url = apiUrl + 'checkProductToAddOrderEdit';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data)
    {
      return response.data;
    }
  }
};

export default {
  namespaced: true,
  actions
}